import NoticeComp from "../../components/notice/NoticeComp";

function Notice() {

  return (
    <NoticeComp/>
  );
}

export default Notice;